"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_number_format_1 = __importDefault(require("react-number-format"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ productId, productIndex, isNotAvailable, salesClosed, }) {
    var _a;
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const cart = (0, react_redux_1.useSelector)((state) => state.cart);
    const cartItemIndex = cart === null || cart === void 0 ? void 0 : cart.findIndex(item => item.id === productId);
    const isInCart = cartItemIndex >= 0;
    const amountInCart = isInCart ? (_a = cart[cartItemIndex]) === null || _a === void 0 ? void 0 : _a.amount : 0;
    const dispatch = (0, react_redux_1.useDispatch)();
    const addProductToCart = () => {
        if (isPreview)
            return;
        if (isInCart)
            dispatch((0, roomViewStore_1.increaseCartItemAmount)(cartItemIndex));
        else
            dispatch((0, roomViewStore_1.addToCart)(productIndex));
    };
    const inputCartAmount = (inputNum) => {
        if (isPreview)
            return;
        dispatch((0, roomViewStore_1.setCartItemAmount)({
            productIndex: isInCart ? 'isInCart' : productIndex,
            cartItemIndex,
            inputNum,
        }));
    };
    const inputRef = (0, react_1.useRef)(null);
    const onInputBlur = (inputNum) => {
        if (isPreview)
            return;
        if (inputNum <= 0) {
            if (isInCart)
                dispatch((0, roomViewStore_1.deleteFromCart)(cartItemIndex));
            else if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
                inputRef.current.value = '0개';
            }
        }
    };
    const removeProductFromCart = () => {
        if (isPreview)
            return;
        if (amountInCart > 1)
            dispatch((0, roomViewStore_1.decreaseCartItemAmount)(cartItemIndex));
        else
            dispatch((0, roomViewStore_1.deleteFromCart)(cartItemIndex));
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(ProductAddDiv, Object.assign({ isNotAvailable: isNotAvailable }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ disabled: !isInCart, onClick: removeProductFromCart }, { children: (0, jsx_runtime_1.jsx)(svgs_1.MinusIconSvg, { css: { path: { strokeOpacity: isInCart ? 1 : 0.1 } } }) })), isNotAvailable ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "product_sold_out" }, { children: t(salesClosed ? '마감' : '품절') }))) : ((0, jsx_runtime_1.jsx)(react_number_format_1.default, { disabled: isPreview, getInputRef: inputRef, allowNegative: false, isAllowed: ({ value }) => Number(value) <= 9999, decimalScale: 0, value: amountInCart, onValueChange: e => {
                    const inputNum = Number(e.value);
                    if (inputNum)
                        inputCartAmount(inputNum);
                }, onBlur: (e) => {
                    const inputNum = Number(e.target.value.replace(/\D/g, ''));
                    onInputBlur(inputNum);
                }, suffix: t('개') })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ disabled: isNotAvailable, onClick: addProductToCart }, { children: (0, jsx_runtime_1.jsx)(svgs_1.PlusIconSvg, { css: { path: { strokeOpacity: isNotAvailable ? 0.1 : 1 } } }) }))] })));
}
exports.default = default_1;
// eslint-disable-next-line prettier/prettier
const ProductAddDiv = styled_1.default.div `
  position: absolute;
  bottom: 0;
  right: 0;
  display: grid;
  grid-template-columns: 24px auto 24px;
  width: 102px;
  height: 36px;
  border: ${props => (props.isNotAvailable ? '1px solid rgba(0, 0, 0, 0.1)' : '1px solid black')};
  border-radius: 100px;
  padding: 4px;
  background-color: white;
  font-size: 12px;
  box-shadow: ${props => (props.isNotAvailable ? 'none' : '0px 2px 5px rgba(0, 0, 0, 0.1)')};
  .MuiIconButton-root {
    padding: 0;
    margin: -5px;
  }
  .product_sold_out {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    border-radius: 2px;
    background-color: #f8f8f8;
    color: rgba(0, 0, 0, 0.2);
  }
  input {
    width: 100%;
    border: 0;
    border-radius: 2px;
    background-color: #f8f8f8;
    text-align: center;
    font-size: 12px;
    :focus {
      outline: none;
      border: 0.5px solid black !important;
      background-color: white;
    }
  }
`;
